<div class="field-modal"> 
      <label class="form-label">{{to.label}}</label>
      <div class="d-flex align-items-center">
            <div (keyup)="onKeyUp($event)" (click)="openModal()">
                  <ng-container #fieldComponent></ng-container>
            </div>
            <span *ngIf="this.formControl.value && formControl.enabled" (click)="onCopyClipboard()"><i class="pi pi-clipboard btn-clipboard" title="Copy to clipboard"></i></span>
            <span class="ml-10">{{ text }}</span>
      </div>
  <div *ngIf="showError" class="error-message">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
</div>
